import Vue from "vue";
import Router from "vue-router";
import login from "../views/login/index.vue";
import dingTalk from "../views/dingTalk/index.vue";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "login",
			component: login
		},
		{
			path: "/dingTalk",
			name: "dingTalk",
			component: dingTalk
		}
	]
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
	// 检查主机名
	if (
		window.location.hostname === "portaltest.ytoglobal.com" ||
		window.location.hostname === "portal.ytoglobal.com"
	) {
		// 首先检查参数中是否包含 source=portal
		const hasPortalSource =
			to.query.source === "portal" ||
			new URLSearchParams(window.location.search).get("source") ===
				"portal";

		// 如果包含 source=portal 参数，无论什么时候都正常访问原页面
		if (hasPortalSource) {
			console.log("检测到 source=portal 参数，正常访问原页面");
			next();
			return;
		}
		// 获取当前时间
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1; // getMonth() 返回 0-11，所以要+1
		const currentDay = currentDate.getDate();

		// 目标时间：2026年4月1日
		const targetYear = 2026;
		const targetMonth = 3;
		const targetDay = 23;

		// 判断当前时间是否在2026年4月1日之后
		// 方法1：比较年月日
		let isAfterTargetDate = false;

		if (currentYear > targetYear) {
			isAfterTargetDate = true;
		} else if (currentYear === targetYear) {
			if (currentMonth > targetMonth) {
				isAfterTargetDate = true;
			} else if (currentMonth === targetMonth) {
				if (currentDay >= targetDay) {
					// 包含4月1日当天
					isAfterTargetDate = true;
				}
			}
		}
		if (isAfterTargetDate) {
			// 2026年4月1日之后，执行跳转
			// 跳转到新地址
			window.location.replace(`https://tms.ytoglobal.com/`);
			return;
		} else {
			// 2026年4月1日之前，正常访问原页面
			console.log("当前时间在2026年4月1日之前，正常访问");
			next();
		}
	} else {
		// 不是 portal 域名，正常访问
		next();
	}
});

export default router;
